import { useCallback } from 'react';
import { PORTFOLIO_DASHBOARD_NOTICE_TYPE_CHANNEL_MANAGER_NOTICES, PORTFOLIO_DASHBOARD_NOTICE_TYPE_DUNNING, PORTFOLIO_DASHBOARD_NOTICE_TYPE_EXPIRED_OPTIONS, PORTFOLIO_DASHBOARD_NOTICE_TYPE_OVERDUE_DEPOSITS } from '../../constants';
import useGlobalSpinner from '../../hooks/useGlobalSpinner';
import { rainbowBaseColors } from '../../palette';
import { handleFetchError, translate } from '../../utils';
import Button from '../Button';

const NOTICE_TYPES_DEFINITIONS = {
    [PORTFOLIO_DASHBOARD_NOTICE_TYPE_CHANNEL_MANAGER_NOTICES]: {
        calloutStyle: { borderLeftColor: rainbowBaseColors[15] }, // Matches the color of the channel manager notices in the sidebar
        labelTranslationKey: 'PORTFOLIO_DASHBOARD_NOTICE_CHANNEL_MANAGER_NOTICES',
        actionPath: '/reservation/index',
    },
    [PORTFOLIO_DASHBOARD_NOTICE_TYPE_EXPIRED_OPTIONS]: {
        calloutStyle: { borderLeftColor: rainbowBaseColors[0] },
        labelTranslationKey: 'PORTFOLIO_DASHBOARD_NOTICE_EXPIRED_OPTIONS',
        actionPath: '/dashboard?noticeTab=expired-options',
    },
    [PORTFOLIO_DASHBOARD_NOTICE_TYPE_OVERDUE_DEPOSITS]: {
        calloutStyle: { borderLeftColor: rainbowBaseColors[1] },
        labelTranslationKey: 'PORTFOLIO_DASHBOARD_NOTICE_OVERDUE_DEPOSITS',
        actionPath: '/overdue-deposits/index',
    },
    [PORTFOLIO_DASHBOARD_NOTICE_TYPE_DUNNING]: {
        calloutStyle: { borderLeftColor: rainbowBaseColors[2] },
        labelTranslationKey: 'PORTFOLIO_DASHBOARD_NOTICE_DUNNING',
        actionPath: '/dunning/index',
    },
};

/** @param {{ notice: import('./portfolioDashboard.types').PortfolioNotice }} props */
export const PortfolioNotice = function PortfolioNotice({ notice }) {
    const [, setIsLoading] = useGlobalSpinner(false);

    const noticeTypeDefinition = NOTICE_TYPES_DEFINITIONS[notice.noticeType];

    const handlePropertyClick = useCallback(async (event) => {
        event.preventDefault();

        const body = new FormData();
        body.append('property_id', event.currentTarget.dataset.propertyId);
        body.append('sourcePath', noticeTypeDefinition.actionPath);

        setIsLoading(true);

        try {
            const response = await fetch('/site/set-property', { method: 'POST', body });

            if (response.ok) {
                window.location.href = (await response.json()).redirectPath;

                return;
            }

            await handleFetchError(response);
        } catch {
            window.alert(translate('frontend', 'ERROR_INPROCESS'));
        }

        setIsLoading(false);
    }, [noticeTypeDefinition, setIsLoading]);

    return (
        <div className="callout callout-info flex justify-between items-start gap-3" style={noticeTypeDefinition.calloutStyle}>
            <div className="flex justify-between gap-3">
                <span className="font-size-h3 text-bold">{notice.totalCount}</span>
                <p>{translate('frontend', noticeTypeDefinition.labelTranslationKey)}</p>
            </div>

            <div className="btn-group">
                <Button type="button" className="btn btn-default btn-sm dropdown-toggle" data-toggle="dropdown">
                    {translate('frontend', 'PORTFOLIO_DASHBOARD_NOTICE_ACTION')} <span className="caret" />
                </Button>

                <ul className="dropdown-menu dropdown-menu-right">
                    {notice.propertiesCounts.map((propertyNoticeCount) => (
                        <li key={propertyNoticeCount.propertyKey}>
                            <a href="#" className="flex justify-between gap-3" data-property-id={propertyNoticeCount.propertyId} onClick={handlePropertyClick}>
                                <span>{propertyNoticeCount.name}</span>
                                <span className="text-bold">{propertyNoticeCount.count}</span>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};
